import React from 'react';

import { SVG } from '.';

export interface IProps {
    className?: string,
    size?: 'm' | 'l'
}

export const IconVerticalLine = ({ size = 'm', ...props }: IProps) => {
    if(size === 'l') {
        return (
            <SVG
                width="2"
                height="36"
                viewBox="0 0 2 36"
                {...props}
            >
                <path
                    d="M1 6L1 28.5"
                    stroke="#8F93A3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </SVG>
        );
    }

    return (
        <SVG
            width="2"
            height="17"
            viewBox="0 0 2 17"
            {...props}
        >
            <path
                d="M1.12793 0.709961L1.12793 15.71"
                stroke="#8F93A3"
                strokeLinecap="round"
            />
        </SVG>
    );
};
